import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { REMOVE_ORGANISATION_LOGO_RESOURCE, ORGANISATION_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const RemoveOrganisationLogoService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ORGANISATION_LOGO_RESOURCE,
      method: 'delete',
      request: (id, organisation, callback, t) => ({
        url: apiRoutes.organisationLogoV2(id),
        meta: {
          callback,
          setOther: {
            resource: ORGANISATION_RESOURCE,
            values: { ...organisation, logoUrl: null },
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeOrganisationLogoFailed'),
            onSuccessMessage: t('removeOrganisationLogoSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveOrganisationLogoService;
